import {
  aStartSumoRecordSearchJob,
  mockStartSumoRecordSearchJobOperationMutation,
} from '__generated__';

export const handlers = [
  mockStartSumoRecordSearchJobOperationMutation((_req, res, ctx) => {
    const { q } = _req.variables;
    const overrides = q === `objectType:\"NetworkProxy"` ? { jobId: '1' } : {};

    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        startSumoRecordSearchJob: aStartSumoRecordSearchJob(overrides),
      })
    );
  }),
];
